import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute(
  '/auswahlfelder/kategorien-nebenbestimmungen/',
)({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="CollateralClauseCategories"
      returnRoute="/auswahlfelder/feeCategories"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const CollateralClauseCategoriesRoute = Route;
